const tables = [
  {
    name: "Number",
  },
  {
    name: "Branch",
  },
  {
    name: "Date",
  },
  {
    name: "Amount",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
